module.exports = __webpack_public_path__ + "img/ex-jt.7f01dbc6.jpg";